
import { FormGroup, ValidationErrors, ValidatorFn, Validators, FormControl } from "@angular/forms";
import { StatementMethod } from "../enums/statementMethod.enum";


/*
  If Statement Method is 
  "WORD DOC EMAIL", => 02
  "EMS & WORD DOC EMAIL", => 03
  "EMS EMAIL", => 30
  "EMS EMAIL AND PAPER STATEMENT", => 32
  "PROP SUM EMS STATEMENT EMAIL", => 35
  "AGENCY SUM EMS STATEMENT EMAIL", => 36
  "EMS WITH TRANS FEES EMAIL" => 38
   or "EMS WITH COMM REDUCED EMAIL" => 40 
  AND the Statement Information tab email is empty or null, 
  then a message indicating that the email is required will be shown. Also, the focus will be put in that field.
*/

export const statementMethodCrossValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {

  const email = control.get('memail');
  const stateMethod = control.get('stateMethod');

  return (stateMethod.value == StatementMethod.WORD_DOC_EMAIL || stateMethod.value == StatementMethod.EMS_WORD_DOC_EMAIL|| stateMethod.value == StatementMethod.EMS_EMAIL ||
        stateMethod.value == StatementMethod.EMS_EMAIL_AND_PAPER_STATEMENT || stateMethod.value == StatementMethod.PROP_SUM_EMS_STATEMENT_EMAIL || 
        stateMethod.value == StatementMethod.AGENCY_SUM_EMS_STATEMENT_EMAIL || stateMethod.value == StatementMethod.EMS_WITH_TRANS_FEES_EMAIL || 
        stateMethod.value == StatementMethod.EMS_WITH_COMM_REDUCED_EMAIL) && (email.value === "") ? {'statementMethodCrossValidator': 'fieldValidation.required'} : null;

};
